import { type TFunction } from 'i18next'
import { type QuestionMeta } from '#types/form/wizard.ts'
import { ipipNeoQuestionsNL } from './utils/ipipQuestions.ts'

export const personalityTestInquiryTree: QuestionMeta = {
	id: 'personalityTestInquiry',
	type: 'REGULAR_QUESTION_TREE',
	leadsToPhase: 'originContextGathering',
	questions: {
		A1: {
			text: 'How are you today?',
			type: 'radio',
			id: 'a1-how-are-you-today',
			options: [
				{
					id: 'a1-how-are-you-today-good',
					text: 'Good',
					nextQuestionId: 'B1',
				},
				{
					id: 'a1-how-are-you-today-bad',
					text: 'Bad',
					nextQuestionId: 'A2-A1',
				},
			],
		},
		'A2-A1': {
			id: 'a2-a1-why-are-you-feeling-bad',
			text: 'Why are you feeling bad?',
			type: 'radio',
			options: [
				{
					id: 'a2-a1-why-are-you-feeling-bad-fired',
					text: 'I got fired',
					nextQuestionId: 'A2-A2-A1',
				},
				{
					id: 'a2-a1-why-are-you-feeling-bad-always-feeling-bad',
					text: 'I am always feeling bad',
					nextQuestionId: 'A2-A2-A1',
				},
			],
		},
		'A2-A2-A1': {
			id: 'a2-a2-a1-tell-us-more-about-your-job-situation',
			text: 'Tell us more about your job situation.',
			type: 'text',
			nextQuestionId: 'A2-A2-B1',
		},
		'A2-A2-B1': {
			id: 'a2-a2-b1-what-do-you-think-influences-your-feelings-the-most',
			text: 'What do you think influences your feelings the most?',
			type: 'radio',
			options: [
				{
					id: 'a2-a2-b1-what-do-you-think-influences-your-feelings-the-most-childhood-trauma',
					text: 'Childhood trauma',
					nextQuestionId: 'B1',
				},
				{
					id: 'a2-a2-b1-what-do-you-think-influences-your-feelings-the-most-my-personality',
					text: 'My personality',
					nextQuestionId: 'B1',
				},
			],
		},
		B1: {
			id: 'b1-what-is-your-favorite-type-of-cuisine',
			text: 'What is your favorite type of cuisine?',
			type: 'radio',
			options: [
				{
					id: 'b1-what-is-your-favorite-type-of-cuisine-italian',
					text: 'Italian',
					nextQuestionId: 'B2',
				},
				{
					id: 'b1-what-is-your-favorite-type-of-cuisine-mexican',
					text: 'Mexican',
					nextQuestionId: 'B2',
				},
				{
					id: 'b1-what-is-your-favorite-type-of-cuisine-japanese',
					text: 'Japanese',
					nextQuestionId: 'END',
				},
			],
		},
		B2: {
			id: 'b2-what-italian-dish-do-you-prefer',
			text: 'What Italian dish do you prefer?',
			type: 'radio',
			options: [
				{
					id: 'b2-what-italian-dish-do-you-prefer-pizza',
					text: 'Pizza',
					nextQuestionId: 'B3',
				},
				{
					id: 'b2-what-italian-dish-do-you-prefer-pasta',
					text: 'Pasta',
					nextQuestionId: 'B3',
				},
			],
		},
		B3: {
			id: 'b3-do-you-enjoy-spicy-food',
			text: 'Do you enjoy spicy food?',
			type: 'radio',
			options: [
				{
					id: 'b3-do-you-enjoy-spicy-food-yes',
					text: 'Yes',
					nextQuestionId: 'END',
				},
				{
					id: 'b3-do-you-enjoy-spicy-food-no',
					text: 'No',
					nextQuestionId: 'END',
				},
			],
		},
	},
}

export const initialQuestionsTree = (t: TFunction): QuestionMeta => {
	return {
		id: 'initialQuestions',
		type: 'REGULAR_QUESTION_TREE',
		leadsToPhase: 'ipipNeo120',
		questions: {
			A1: {
				text: t('a1.gender'),
				type: 'radio',
				id: 'a1-gender',
				options: [
					{
						id: 'male',
						text: t('a1.male'),
						nextQuestionId: 'A2',
					},
					{
						id: 'female',
						text: t('a1.female'),
						nextQuestionId: 'A2',
					},
					// {
					// 	id: 'a1-gender-other',
					// 	text: t('a1.other'),
					// 	nextQuestionId: 'A2',
					// },
				],
			},
			A2: {
				text: t('a2.age'),
				type: 'number',
				id: 'a2-age',
				nextQuestionId: 'END',
			},
			// A2: {
			// 	text: t('a2.age'),
			// 	type: 'number',
			// 	id: 'a2-age',
			// 	nextQuestionId: 'A3',
			// },
			// A3: {
			// 	text: t('a3.religious'),
			// 	type: 'radio',
			// 	id: 'a3-religion',
			// 	options: [
			// 		{
			// 			id: 'a3-religion-yes',
			// 			text: t('a3.yes'),
			// 			nextQuestionId: 'A3-A1',
			// 		},
			// 		{
			// 			id: 'a3-religion-no',
			// 			text: t('a3.no'),
			// 			nextQuestionId: 'A4',
			// 		},
			// 	],
			// },
			// 'A3-A1': {
			// 	id: 'a3-a1-religion-which-religion',
			// 	text: t('a3-a1.whichReligion'),
			// 	type: 'radio',
			// 	options: [
			// 		{
			// 			id: 'a3-a1-religion-which-religion-christianity',
			// 			text: t('a3-a1.christianity'),
			// 			nextQuestionId: 'A4',
			// 		},
			// 		{
			// 			id: 'a3-a1-religion-which-religion-islam',
			// 			text: t('a3-a1.islam'),
			// 			nextQuestionId: 'A4',
			// 		},
			// 		{
			// 			id: 'a3-a1-religion-which-religion-hinduism',
			// 			text: t('a3-a1.hinduism'),
			// 			nextQuestionId: 'A4',
			// 		},
			// 		{
			// 			id: 'a3-a1-religion-which-religion-buddhism',
			// 			text: t('a3-a1.buddhism'),
			// 			nextQuestionId: 'A4',
			// 		},
			// 		{
			// 			id: 'a3-a1-religion-which-religion-judaism',
			// 			text: t('a3-a1.judaism'),
			// 			nextQuestionId: 'A4',
			// 		},
			// 		{
			// 			id: 'a3-a1-religion-which-religion-other',
			// 			text: t('a3-a1.other'),
			// 			nextQuestionId: 'A4',
			// 		},
			// 	],
			// },
			// A4: {
			// 	text: t('a4.spiritual'),
			// 	type: 'radio',
			// 	id: 'a4-spiritual',
			// 	options: [
			// 		{
			// 			id: 'a4-spiritual-yes',
			// 			text: t('a4.yes'),
			// 			nextQuestionId: 'A5',
			// 		},
			// 		{
			// 			id: 'a4-spiritual-no',
			// 			text: t('a4.no'),
			// 			nextQuestionId: 'A5',
			// 		},
			// 	],
			// },
			// A5: {
			// 	text: t('a5.socialLife'),
			// 	type: 'radio',
			// 	id: 'a5-social-life-rating',
			// 	options: [
			// 		{
			// 			id: 'a5-social-life-rating-1',
			// 			text: t('veryLow', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A6',
			// 			includedQuestions: ['socialLife'],
			// 		},
			// 		{
			// 			id: 'a5-social-life-rating-2',
			// 			text: t('low', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A6',
			// 			includedQuestions: ['socialLife'],
			// 		},
			// 		{
			// 			id: 'a5-social-life-rating-3',
			// 			text: t('neutral', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A6',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a5-social-life-rating-4',
			// 			text: t('high', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A6',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a5-social-life-rating-5',
			// 			text: t('veryHigh', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A6',
			// 			includedQuestions: [],
			// 		},
			// 	],
			// },
			// A6: {
			// 	text: t('a6.financialSituation'),
			// 	type: 'radio',
			// 	id: 'a6-financial-situation-rating',
			// 	options: [
			// 		{
			// 			id: 'a6-financial-situation-rating-1',
			// 			text: t('veryLow', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A7',
			// 			includedQuestions: ['financialSituationLife'],
			// 		},
			// 		{
			// 			id: 'a6-financial-situation-rating-2',
			// 			text: t('low', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A7',
			// 			includedQuestions: ['financialSituationLife'],
			// 		},
			// 		{
			// 			id: 'a6-financial-situation-rating-3',
			// 			text: t('neutral', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A7',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a6-financial-situation-rating-4',
			// 			text: t('high', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A7',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a6-financial-situation-rating-5',
			// 			text: t('veryHigh', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A7',
			// 			includedQuestions: [],
			// 		},
			// 	],
			// },
			// A7: {
			// 	text: t('a7.healthLife'),
			// 	type: 'radio',
			// 	id: 'a7-health-rating',
			// 	options: [
			// 		{
			// 			id: 'a7-health-rating-1',
			// 			text: t('veryLow', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A8',
			// 			includedQuestions: ['healthLife'],
			// 		},
			// 		{
			// 			id: 'a7-health-rating-2',
			// 			text: t('low', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A8',
			// 			includedQuestions: ['healthLife'],
			// 		},
			// 		{
			// 			id: 'a7-health-rating-3',
			// 			text: t('neutral', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A8',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a7-health-rating-4',
			// 			text: t('high', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A8',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a7-health-rating-5',
			// 			text: t('veryHigh', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A8',
			// 			includedQuestions: [],
			// 		},
			// 	],
			// },
			// A8: {
			// 	text: t('a8.workLife'),
			// 	type: 'radio',
			// 	id: 'a8-work-rating',
			// 	options: [
			// 		{
			// 			id: 'a8-work-rating-1',
			// 			text: t('veryLow', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A9',
			// 			includedQuestions: ['workLife'],
			// 		},
			// 		{
			// 			id: 'a8-work-rating-2',
			// 			text: t('low', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A9',
			// 			includedQuestions: ['workLife'],
			// 		},
			// 		{
			// 			id: 'a8-work-rating-3',
			// 			text: t('neutral', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A9',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a8-work-rating-4',
			// 			text: t('high', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A9',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a8-work-rating-5',
			// 			text: t('veryHigh', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A9',
			// 			includedQuestions: [],
			// 		},
			// 	],
			// },
			// A9: {
			// 	text: t('a9.relationshipLife'),
			// 	type: 'radio',
			// 	id: 'a9-relationship-rating',
			// 	options: [
			// 		{
			// 			id: 'a9-relationship-rating-1',
			// 			text: t('veryLow', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A10',
			// 			includedQuestions: ['relationshipLife'],
			// 		},
			// 		{
			// 			id: 'a9-relationship-rating-2',
			// 			text: t('low', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A10',
			// 			includedQuestions: ['relationshipLife'],
			// 		},
			// 		{
			// 			id: 'a9-relationship-rating-3',
			// 			text: t('neutral', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A10',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a9-relationship-rating-4',
			// 			text: t('high', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A10',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a9-relationship-rating-5',
			// 			text: t('veryHigh', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'A10',
			// 			includedQuestions: [],
			// 		},
			// 	],
			// },

			// A10: {
			// 	text: t('a10.familyLife'),
			// 	type: 'radio',
			// 	id: 'a10-family-rating',
			// 	options: [
			// 		{
			// 			id: 'a10-family-rating-1',
			// 			text: t('veryLow', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'END',
			// 			includedQuestions: ['familyLife'],
			// 		},
			// 		{
			// 			id: 'a10-family-rating-2',
			// 			text: t('low', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'END',
			// 			includedQuestions: ['familyLife'],
			// 		},
			// 		{
			// 			id: 'a10-family-rating-3',
			// 			text: t('neutral', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'END',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a10-family-rating-4',
			// 			text: t('high', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'END',
			// 			includedQuestions: [],
			// 		},
			// 		{
			// 			id: 'a10-family-rating-5',
			// 			text: t('veryHigh', { ns: 'ratingSystem' }),
			// 			nextQuestionId: 'END',
			// 			includedQuestions: [],
			// 		},
			// 	],
			// },
		},
	}
}

function createQuestions(t: TFunction) {
	const questions: any = {}

	for (let i = 0; i < 120; i++) {
		const questionId = `A${i + 1}`
		const nextQuestionId = i < 119 ? `A${i + 2}` : 'END'

		questions[questionId] = {
			id: ipipNeoQuestionsNL[i].code,
			text: t(`i${i + 1}`, { ns: 'ipipNeoTest' }),
			type: 'radio',
			options: [
				{
					id: `${ipipNeoQuestionsNL[i].code}-1`,
					text: t('veryLow', { ns: 'ratingSystem' }),
					nextQuestionId,
				},
				{
					id: `${ipipNeoQuestionsNL[i].code}-2`,
					text: t('low', { ns: 'ratingSystem' }),
					nextQuestionId,
				},
				{
					id: `${ipipNeoQuestionsNL[i].code}-3`,
					text: t('neutral', { ns: 'ratingSystem' }),
					nextQuestionId,
				},
				{
					id: `${ipipNeoQuestionsNL[i].code}-4`,
					text: t('high', { ns: 'ratingSystem' }),
					nextQuestionId,
				},
				{
					id: `${ipipNeoQuestionsNL[i].code}-5`,
					text: t('veryHigh', { ns: 'ratingSystem' }),
					nextQuestionId,
				},
			],
		}
	}

	return questions
}
export const ipipNeo120Tree = (t: TFunction): QuestionMeta => ({
	id: 'ipipNeo120',
	type: 'REGULAR_QUESTION_TREE',
	leadsToPhase: 'endOfForm',
	questions: createQuestions(t),
})
